import { UseControllerProps, UseFormSetValue } from "react-hook-form";
import { Box } from "@mantine/core";

import LoadingSkeleton from "./LoadingSkeleton";
import ImageUploader from "./ImageUploader";

import { useImageUpload } from "../../../../../hooks/mutations/useImageUpload";
import { ITheme } from "../../../../../typings/Theme";
import EditorLabel from "../EditorLabel";

type Props = {
  name: UseControllerProps<ITheme>["name"];
  label?: string;
  hint?: string;
  imageUrl?: string;
  localeSwitcher?: React.ReactNode;
  setValue: UseFormSetValue<ITheme>;
};

const ImageEditor = ({ name, label, hint, imageUrl, localeSwitcher, setValue }: Props) => {
  const { mutate: mutateImageUpload, isLoading } = useImageUpload();
  const suffix = name.split(".").pop() as string;

  const onChange = (image: File | null) => {
    const imageIDFormName = name.replace(suffix, "imageId") as UseControllerProps<ITheme>["name"];
    const metadataFormName = name.replace(suffix, "metadata") as UseControllerProps<ITheme>["name"];

    if (image) {
      mutateImageUpload({
        image,
        onSuccess({ id, url, metadata }) {
          setValue(name, url);
          setValue(imageIDFormName, id);
          setValue(metadataFormName, metadata);
        },
      });
    } else {
      setValue(name, undefined);
      setValue(imageIDFormName, undefined);
      setValue(metadataFormName, undefined);
    }
  };

  return (
    <Box>
      {label && <EditorLabel label={label} hint={hint} localeSwitcher={localeSwitcher} />}
      {isLoading ? <LoadingSkeleton /> : <ImageUploader label={label} imageUrl={imageUrl} onChange={onChange} />}
    </Box>
  );
};

export default ImageEditor;
